module.exports = __webpack_public_path__ + "static/media/number8.7098d36d.svg";